import { MegamenuItem, NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
import __megamenu from "./jsons/__megamenu.json";

export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
    type: "dropdown",
    // children: demoChildMenus,
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/listing-car",
    name: "Our Fleet",
    type: "megaMenu",
    // megaMenu: megaMenuDemo,
  },
  {
    id: ncNanoId(),
    href: "/about",
    name: "About Us",
    type: "megaMenu",
    // megaMenu: megaMenuDemo,
  },

  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact Us",
    type: "megaMenu",
    // megaMenu: megaMenuDemo,
  },
];
